"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavLi = _styledComponents["default"].li.withConfig({
  displayName: "SideBarNavItem__NavLi",
  componentId: "sc-1dedapz-0"
})(function (props) {
  return (0, _styledComponents.css)(["vertical-align:middle;min-width:2rem;list-style-type:none;a{display:flex;align-items:center;text-decoration:none;color:", ";font-weight:bold;border-radius:0.4rem;transition:border-radius 0.5s;min-height:2rem;outline:none;padding-left:0.5rem;&:hover{box-shadow:", ";}&:focus{box-shadow:0 0 0 0.25rem ", ";}svg path{fill:", ";}span{display:inline-block;overflow:hidden;opacity:1;white-space:nowrap;transition:", ";text-indent:1rem;}}", " > .active-link{background:", ";color:", ";svg path{fill:", ";}}"], props.theme.color.action, props.disabled ? 'none' : "0 0 0 0.25rem ".concat(props.theme.color.hover), props.theme.color.focus, props.theme.color.action, _units.transition.textSlideInOutOpacityIndent, function (props) {
    return props.collapsed && (0, _styledComponents.css)(["margin-right:0.5rem;a{border-radius:50%;span{text-indent:-30rem;opacity:0;}}"]);
  }, props.theme.color.action, props.theme.color.paper, props.theme.color.paper);
});
/**
 *
 * #### Link inserted into SideBarNavItemContainer

When creating Sidebar links sections we need to follow a pattern of organising Links inside the **SideBarNavItemContainer** component.
In order to do this correctly **SideBarNavItem** components need to be equipped with **to** property assigned a string of text with the path associated with the link, a **label**

 */


var SideBarNavItem = function SideBarNavItem(_ref) {
  var icon = _ref.icon,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? '/' : _ref$to,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed;
  return /*#__PURE__*/_react["default"].createElement(NavLi, {
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    activeClassName: "active-link",
    to: to
  }, icon && /*#__PURE__*/_react["default"].cloneElement(icon, {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement("span", null, label)));
};

var _default = SideBarNavItem;
exports["default"] = _default;